import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { Badge } from '../ui/Badge';
import { naira } from '../../utils/format';
import { ORIGIN_LABEL, ORIGIN_TONE, feeTotals } from '../../utils/services';
import type { AcademicService } from '../../types/services';
export function ServiceCard({
  service,
  onOpen
}: {
  service: AcademicService;
  onOpen: () => void;
}) {
  const totals = feeTotals(service.fees);
  return <button type="button" onClick={onOpen} className="flex w-full items-start gap-3 rounded-card border border-line bg-surface px-4 py-3.5 text-left transition-colors duration-150 ease-out hover:border-ink-subtle" data-id="element-5005" data-mp="2jlf1m2ai2vg">
      <div className="min-w-0 flex-1" data-id="element-5006" data-mp="cen5cl8axazm">
        <div className="flex flex-wrap items-center gap-2" data-id="element-5007" data-mp="7hn6au9vd8i0">
          <p className="text-[14px] font-semibold text-ink" data-id="element-5008" data-mp="7k9caph43fy4">{service.name}</p>
          <Badge tone={ORIGIN_TONE[service.origin]} data-id="element-5009" data-mp="1nubthfxakg20">{ORIGIN_LABEL[service.origin]}</Badge>
          {!service.catalogueVerified && <Badge tone="warn" data-id="element-5010" data-mp="3k7xcn9dggii9">Details not confirmed with the institution</Badge>}
        </div>
        <p className="mt-1 text-[13px] leading-6 text-ink-muted" data-id="element-5011" data-mp="3p68o1ojef12l">{service.description}</p>
        <p className="mt-1.5 flex flex-wrap gap-x-3 gap-y-0.5 text-[12px] text-ink-subtle" data-id="element-5012" data-mp="3u64fypetn21s">
          <span data-id="element-5013" data-mp="2zjsffnz6c9i">{service.category}</span>
          <span data-id="element-5014" data-mp="2yiixfmlxxtw">
            {totals.hasUnknown && totals.total === 0 ? 'Fee not published' : `From ${naira(totals.total)}`}
          </span>
          <span data-id="element-5015" data-mp="36g0mhavckioi">{service.processingEstimate ?? 'Timeline not published'}</span>
        </p>
      </div>
      <ChevronRightIcon className="mt-1 h-4 w-4 shrink-0 text-ink-subtle" data-id="element-5016" data-mp="3bets6h4e75e4" />
    </button>;
}